import React from 'react'
import { Col } from 'react-bootstrap'
import './SunglassesCard.css';

const SunglassesCard = ({ src, idx }) => {
    return (
        <Col xs={12} sm={6} lg={3}>
            <div className="sunglasses-card h-100 d-flex flex-column">
                <div className="sunglasses-card-image-wrap">
                    <img src={src.src} alt={`Gunmetal sunglasses ${idx + 1}`} className="sunglasses-card-image" />
                </div>
                <div className="sunglasses-card-body">
                    <div className="sunglasses-card-name">{src.desc}</div>
                    <div className="sunglasses-card-brand">{src.title}</div>
                </div>
            </div>
        </Col>
    )
}

export default SunglassesCard